import { render } from "./MyAssets.vue?vue&type=template&id=ea1847c6&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"

import "./MyAssets.vue?vue&type=style&index=0&id=ea1847c6&lang=scss"
import "./MyAssets.vue?vue&type=style&index=1&id=ea1847c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea1847c6"]])

export default __exports__